import { matchPath } from '@direct-frontend/modules-router';
import { ordersImportExcelRoute, ordersRoute } from '../routes';

/** Маршруты с поддержкой мобильной вёрстки кабинета */
const MOBILE_ROUTES = [ordersRoute.route, ordersImportExcelRoute.route] as const;

export const isMobileRoute = (pathname: string): boolean =>
    MOBILE_ROUTES.some((pattern) => Boolean(matchPath(pattern, pathname)));
